"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _DraggingParameter_parameterManager, _DraggingParameter_sessionEngineCore;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggingParameter = void 0;
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const Parameter_1 = require("../Parameter");
class DraggingParameter extends Parameter_1.Parameter {
    constructor(paramDef, sessionEngineCore, parameterManager) {
        super(paramDef, sessionEngineCore, parameterManager);
        _DraggingParameter_parameterManager.set(this, void 0);
        _DraggingParameter_sessionEngineCore.set(this, void 0);
        __classPrivateFieldSet(this, _DraggingParameter_sessionEngineCore, sessionEngineCore, "f");
        __classPrivateFieldSet(this, _DraggingParameter_parameterManager, parameterManager, "f");
    }
    get draggingColor() {
        var _a;
        return (_a = this.getDraggingProperties()) === null || _a === void 0 ? void 0 : _a.draggingColor;
    }
    get hover() {
        var _a;
        return (_a = this.getDraggingProperties()) === null || _a === void 0 ? void 0 : _a.hover;
    }
    get hoverColor() {
        var _a;
        return (_a = this.getDraggingProperties()) === null || _a === void 0 ? void 0 : _a.hoverColor;
    }
    get interactionType() {
        return "dragging";
    }
    get objects() {
        var _a;
        return (_a = this.getDraggingProperties()) === null || _a === void 0 ? void 0 : _a.objects;
    }
    get restrictions() {
        var _a;
        return (_a = this.getDraggingProperties()) === null || _a === void 0 ? void 0 : _a.restrictions;
    }
    getDraggingProperties() {
        const result = (0, viewer_shared_types_1.validateDraggingParameterSettings)(this.settings);
        if (result.success) {
            return this.settings
                .props;
        }
    }
}
exports.DraggingParameter = DraggingParameter;
_DraggingParameter_parameterManager = new WeakMap(), _DraggingParameter_sessionEngineCore = new WeakMap();
//# sourceMappingURL=DraggingParameter.js.map